export const GeoRiskData = [
    {
        "latitude": 20.5937,
        "longitude": 78.9629,
        "risk": 2,
    },
    {
        "latitude": 4.28,
        "longitude": 69.11,
        "risk": 1,
    },
    {
        "latitude": -27,
        "longitude": 133,
        "risk": 3,
    },
    {
        "country": "Barbados",
        "alpha2": "BB",
        "alpha3": "BRB",
        "risk": 1,
        "latitude": 13.1667,
        "longitude": -59.5333
    },
    {
        "country": "Belarus",
        "alpha2": "BY",
        "alpha3": "BLR",
        "risk": 2,
        "latitude": 53,
        "longitude": 28
    },
    {
        "country": "Belgium",
        "alpha2": "BE",
        "alpha3": "BEL",
        "risk": 3,
        "latitude": 50.8333,
        "longitude": 4
    },
    {
        "country": "Belize",
        "alpha2": "BZ",
        "alpha3": "BLZ",
        "risk": 1,
        "latitude": 17.25,
        "longitude": -88.75
    },
    {
        "country": "Cameroon",
        "alpha2": "CM",
        "alpha3": "CMR",
        "risk": 3,
        "latitude": 6,
        "longitude": 12
    },
    {
        "country": "Canada",
        "alpha2": "CA",
        "alpha3": "CAN",
        "risk": 2,
        "latitude": 60,
        "longitude": -95
    },
    {
        "country": "France",
        "alpha2": "FR",
        "alpha3": "FRA",
        "risk": 2,
        "latitude": 46,
        "longitude": 2
    },
    {
        "country": "Greece",
        "alpha2": "GR",
        "alpha3": "GRC",
        "risk": 1,
        "latitude": 39,
        "longitude": 22
    },
    {
        "country": "Italy",
        "alpha2": "IT",
        "alpha3": "ITA",
        "risk": 2,
        "latitude": 42.8333,
        "longitude": 12.8333
    },
    {
        "country": "Jamaica",
        "alpha2": "JM",
        "alpha3": "JAM",
        "risk": 1,
        "latitude": 18.25,
        "longitude": -77.5
    },
    {
        "country": "Madagascar",
        "alpha2": "MG",
        "alpha3": "MDG",
        "risk": 450,
        "latitude": -20,
        "longitude": 47
    },
    {
        "country": "Netherlands",
        "alpha2": "NL",
        "alpha3": "NLD",
        "risk": 1,
        "latitude": 52.5,
        "longitude": 5.75
    },
    {
        "country": "Nigeria",
        "alpha2": "NG",
        "alpha3": "NGA",
        "risk": 1,
        "latitude": 10,
        "longitude": 8
    },
    {
        "country": "Norway",
        "alpha2": "NO",
        "alpha3": "NOR",
        "risk": 2,
        "latitude": 62,
        "longitude": 10
    },
    {
        "country": "Philippines",
        "alpha2": "PH",
        "alpha3": "PHL",
        "risk": 3,
        "latitude": 13,
        "longitude": 122
    },
    {
        "country": "Qatar",
        "alpha2": "QA",
        "alpha3": "QAT",
        "risk": 3,
        "latitude": 25.5,
        "longitude": 51.25
    },
    {
        "country": "Poland",
        "alpha2": "PL",
        "alpha3": "POL",
        "risk": 3,
        "latitude": 52,
        "longitude": 20
    },
    {
        "country": "Serbia",
        "alpha2": "RS",
        "alpha3": "SRB",
        "risk": 2,
        "latitude": 44,
        "longitude": 21
    },
    {
        "country": "Zimbabwe",
        "alpha2": "ZW",
        "alpha3": "ZWE",
        "risk": 2,
        "latitude": -20,
        "longitude": 30
    },
    {
        "country": "Yemen",
        "alpha2": "YE",
        "alpha3": "YEM",
        "risk": 2,
        "latitude": 15,
        "longitude": 48
    },
]